import { $display } from './context.js'
import { selectVariant } from './variant-swiper.js'

/**
 * Refleja la variante seleccionada en la URL (?v={id}) sin recargar la página.
 * @param {string} id
 */
const updateVariantUrl = (id) => {
    const url = new URL(window.location.href)
    if (id) {
        url.searchParams.set('v', id)
    } else {
        url.searchParams.delete('v')
    }
    history.replaceState({ url: url.toString() }, document.title, url.toString())
    $display.attr('data-variant', id)
}

/**
 * Vincula la selección de variantes desde la cinta de thumbs.
 */
export const initVariantNavigation = () => {
    $display.on('click', '.variant-card', (event, self) => {
        const id = self.data('variant-id')
        if (!id) return

        selectVariant(id, 300)
        updateVariantUrl(id)
    })

    $display.on('keydown', '.variant-card', (event, self) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            self.click()
        }
    })
}
